import { defineComponent as _defineComponent } from 'vue'
import Info from '@/components/DynamicInfo.vue';
import CapaLivro from './CapaLivro.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import TabelaCapitulos from './TabelaCapitulos.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { formatarPublicacoes } from '@/utils/util';
import { useVuetify } from '@/composables/useVuetify';
import { download } from '@/utils/downloadDocs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposLivro',
  setup(__props) {

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);


return { __sfc: true,vuetify, store, obra, Info, CapaLivro, TabelaLocalizacao, TabelaCapitulos, formatarPublicacoes, download }
}

})